import { FrontChat } from "components/FrontChat";
import { ChatSurfaceCoordinatorProvider } from "providers/ChatSurfaceCoordinator";

import { Appcues } from "../../components/Appcues";
import { Layout } from "../../components/Layout";

export function Customer() {
  return (
    <ChatSurfaceCoordinatorProvider>
      <Appcues />
      <FrontChat />
      <Layout />
    </ChatSurfaceCoordinatorProvider>
  );
}
